import { render, staticRenderFns } from "./EditarAlmacen.vue?vue&type=template&id=6992ce9c"
import script from "./EditarAlmacen.vue?vue&type=script&lang=js"
export * from "./EditarAlmacen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports